<sm-dialog-template [header]="tips()[tipIndex()].title"
                    iconClass="al-ico-tips"
                    (xClicked)="matDialogRef.close(neverShowAgain())"
>
  <div class="tip-container" smClickStopPropagation>
    @if (tips()[tipIndex()].image) {
      <div
        class="tip-image"
        [class.full-width]="!tips()[tipIndex()].content"
        [style.background-image]="'url(' + getThemeImageSrc(tips()[tipIndex()].image) + ')'"></div>
    }
    @if (tips()[tipIndex()].content) {
      <div class="tip-content" [class.full-width]="!tips()[tipIndex()].image">
      <div
        class="tip-content"
        [innerHTML]="tips()[tipIndex()].content | purify"></div>
      </div>
    }
  </div>

  <div class="footer" [class.no-gap]="hideDontShow() && tips().length === 1">
    <div class="tip-dont-show" [class.invisible]="hideDontShow()"
         smTooltip="Can also be set from the User Preferences section in the Profile page"

         matTooltipShowDelay="300">
      <mat-checkbox [(ngModel)]="neverShowAgain">
        <span class="tip-cbx">Don't show again</span>
      </mat-checkbox>
    </div>
    @if (tips().length > 1) {
      <div class="navigate">
        <div class="btn-rec al-icon al-ico-previous" data-id="previousButton" (click)="prev()"></div>
        <div class="btn-rec al-icon al-ico-next" data-id="nextButton" (click)="next()"></div>
      </div>
      <div class="tip-page" data-id="proTipsPageCount"> {{ tipIndex() + 1 }} / {{ tips().length }}</div>
    }
  </div>
</sm-dialog-template>
